import { useState } from "react";
import "../styles/AdminLogin.css";

const ADMIN_PW = "Dickson-2027";

export default function AdminLogin({ onAuth }) {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");

  function login() {
    if (pw === ADMIN_PW) {
      onAuth();
    } else {
      setErr("Incorrect password.");
    }
  }

  return (
    <div className="page">
      <div className="login-wrap">
        <div className="login-box">
          <div className="login-ornament">🔑</div>
          <div className="login-title">Admin Access</div>
          <div className="login-sub">
            Enter the password to manage gallery content.
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              className="form-control"
              type="password"
              placeholder="Enter password…"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && login()}
            />
          </div>

          {err && <div className="error-msg">{err}</div>}

          <button
            className="btn btn-primary"
            style={{ width: "100%" }}
            onClick={login}
          >
            Enter →
          </button>

          <p className="login-hint"></p>
        </div>
      </div>
    </div>
  );
}
